module.exports = __webpack_public_path__ + "img/4.fde858a9.jpg";